import { faker } from '@faker-js/faker'

const generateEquipment = (index) => ({
  equipmentId: faker.string.uuid(),
  name: `Bed ${index + 1}`,
  timerId: index + 1,
  status: 'available',
  category: index % 2 === 0 ? 'UV' : 'regular',
  nonUvCategory: index % 2 !== 0 ? 'spa' : null,
  qualityCategory: ['silver', 'gold', 'platinum', 'diamond'][index % 4],
  image: null,
  manufacturer: 'Test Manufacturer',
  description: `Test equipment ${index + 1}`,
  minDelayMinutes: 1,
  maxDelayMinutes: 10,
  defaultDelayMinutes: 3,
  minTimerMinutes: 1,
  maxTimerMinutes: 30,
  defaultTimerMinutes: 10,
  lastAvailableAt: null,
  lastDelayAt: null,
  lastInUseAt: null,
  lastDirtyAt: null,
  currentError: null,
  lastError: null,
  queue: [],
  assignments: [],
})

export const EQUIPMENTS_MOCK = {
  equipments: Array.from({ length: 8 }, (_, i) => generateEquipment(i)),
}

export const AVAILABLE_EQUIPMENTS_MOCK = EQUIPMENTS_MOCK.equipments
  .filter((eq) => eq.status === 'available')
  .map(({ equipmentId, image }) => ({ equipmentId, image }))
